module.exports = __webpack_public_path__ + "static/media/about-img1.da110d80.svg";